let talentRequestsData = {
  "team_with_x": {
    "months": [
      1,
      2
    ],
    "display_name": "Team With X",
    "name": "Team With ${talentName}",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "${talentName} and I have decent chemistry. It would be a good idea to put us in a team together.",
      "I've been thinking about getting into the tag division for a while now. I've had talks with ${talentName} and we both agreed to team up.",
      "${talentName} and I were thinking about teaming up. We both know we could do really well together."
    ],
    "description": "More likely by talent with the Tag Team Specialist trait.",
    "conflicting_requests": [
      "write_off",
      "no_weekly_shows",
      "change_brand"
    ],
    "rarity": "uncommon"
  },
  "solo_promo_segment": {
    "allow_managers": true,
    "months": [
      1
    ],
    "display_name": "Have A Solo Promo Segment",
    "name": "Have A Solo Promo Segment",
    "importance": "minor",
    "dialogs": [
      "I'd like to showcase my character a bit. Could you book me in a solo promo segment this month?",
      "I feel like going out there for a solo promo. It might help me connect with the fans.",
      "I would appreciate some solo mic time. How about a promo segment where it's just me talking?",
      "Hey, how about some mic time? A solo promo slot would be perfect."
    ],
    "description": "More likely by talent with 2 Charisma and those with the Spotlight Lover trait.",
    "conflicting_requests": [
      "no_weekly_shows"
    ],
    "rarity": "common"
  },
  "win_next_match": {
    "months": [
      1
    ],
    "display_name": "Win Next Match",
    "name": "Win Next Match (Singles)",
    "importance": "minor",
    "dialogs": [
      "I've been on a bit of a losing streak. How about giving me a win, boss?",
      "It doesn't feel good to take so many losses. A win would really help my character out.",
      "You might not know this, but losing isn't the best feeling. Could you please book me to win my next match?",
      "I don't know what your plan is with my recent losses, but getting a win next could help turn things around.",
      "I noticed I've been taking a bunch of losses recently. Getting a win in my next match would be nice."
    ],
    "description": "More likely by talent with 5+ match losing streaks and those with the Hard To Please or Rebel traits.",
    "conflicting_requests": [
      "lose_next_match",
      "no_weekly_shows"
    ],
    "rarity": "common"
  },
  "debut_new_gimmick": {
    "allow_managers": true,
    "months": [
      1
    ],
    "display_name": "Debut New Gimmick",
    "name": "Debut New Gimmick",
    "importance": "minor",
    "dialogs": [
      "I don't know if you can tell, but I'm not too popular with the fans right now. Maybe introducing a new gimmick could help me out?",
      "You know what's a great way to refresh my character? Coming out with a cool new gimmick, something the fans will be interested in.",
      "The fans are not too hot on me these days. How about I debut a new gimmick that freshens up my character?"
    ],
    "description": "More likely by Stale talent.",
    "conflicting_requests": [
      "write_off"
    ],
    "rarity": "uncommon"
  },
  "be_in_title_match": {
    "months": [
      1,
      2
    ],
    "display_name": "Be In A Title Match",
    "name": "Be In A Title Match",
    "importance": "minor",
    "dialogs": [
      "Being in a title match would really help my character out. A match with real stakes, where I can show the fans what I got.",
      "I could really use a title match right now. I'll make any champion look good, even in defeat.",
      "You know that a title match can elevate all participants. If you put me in one, I'll make sure it's a great match.",
      "I somehow keep getting the urge to be in a title match. Could you book me in one so I can shine out there?"
    ],
    "description": "More likely by Unhappy talent, Upper Midcarders and those with the Spotlight Lover trait.",
    "conflicting_requests": [],
    "rarity": "common"
  },
  "lose_championship": {
    "months": [
      1,
      2
    ],
    "display_name": "Lose Championship",
    "name": "Lose ${championshipName} Championship",
    "get_action_data": true,
    "importance": "major",
    "dialogs": [
      "This is hard to say .. I think it's time for me to drop the ${championshipName} Title to someone else. Being the champion is taking its toll on me.",
      "I'm sorry, but I can't be the ${championshipName} Champion any longer. I have other things going on in my life right now .. I'd like to drop the title soon.",
      "The ${championshipName} Championship is being wasted on me. You should have me lose the title to someone who can do better things with it."
    ],
    "description": "More likely by talent leaving the Company, Unhappy talent and those with the Big Stage Wreck, Other Interests or Extreme Emotions traits.",
    "conflicting_requests": [
      "customize_championship"
    ],
    "rarity": "rare"
  },
  "leave_faction": {
    "months": [
      2,
      3
    ],
    "display_name": "Leave Faction",
    "name": "Leave Faction (${factionName})",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "I keep getting the feeling that I don't belong in ${factionName}. Don't get me wrong, it's been good, but I could do better things outside of it.",
      "You know, it would be a really cool story if I slowly left ${factionName}. I think now's the time to do it.",
      "I had a talk with all members of ${factionName}, and we agreed that it's best for me to leave so I can do my own thing.",
      "Maybe it's time for me to break away from ${factionName}. I'll be able to do bigger things outside of it. Plus, it would make for a nice angle."
    ],
    "description": "More likely by Over talent.",
    "conflicting_requests": [],
    "rarity": "uncommon"
  },
  "be_managed": {
    "months": [
      1
    ],
    "display_name": "Be Managed",
    "name": "Be Managed",
    "importance": "minor",
    "dialogs": [
      "I'm sure you've noticed my lack of skills on the mic. How about you assign me someone to do the talking for me?",
      "I feel like I need a manager assigned to me, someone who can hide my shortcomings. Don't you agree?",
      "I could do a lot better if I had a manager paired up with me. Someone who can do the talking and make me look good.",
      "You know what I need to progress further? A skilled manager. Someone who adds to my presence and aura."
    ],
    "description": "More likely by talent with 1 Charisma.",
    "conflicting_requests": [
      "write_off",
      "no_weekly_shows"
    ],
    "rarity": "uncommon"
  },
  "start_faction": {
    "months": [
      1,
      2
    ],
    "display_name": "Start A Faction",
    "name": "Start A Faction",
    "importance": "minor",
    "dialogs": [
      "I'm a big fan of factions. If you put me in one with a few other talented superstars, we could all help each other out.",
      "The stories on the show needs some freshening up, and a new faction is the perfect way to do that. You can pick some other superstars and start one with me.",
      "A lot of wrestlers could benefit from being part of a group, myself included. How about you put a few of us together in a new faction?"
    ],
    "description": "More likely by Upper Midcarders.",
    "conflicting_requests": [
      "write_off",
      "no_weekly_shows",
      "change_brand"
    ],
    "rarity": "uncommon"
  },
  "manage_x": {
    "allow_managers": true,
    "months": [
      1
    ],
    "display_name": "Manage X",
    "name": "Manage ${talentName}",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "${talentName} is a special talent who needs a little help on the mic. I think I would be a good fit as ${talentPossessive} manager.",
      "It's time for me to use my manager skills to push someone up the card. How about ${talentName}? I know we'd make a great pairing.",
      "I've been scouting talent to manage recently, and I see ${talentName} as someone who could really benefit from my abilities.",
      "I've been coaching ${talentName} a bit backstage, and I know I could make a real difference if you made me ${talentPossessive} on-screen manager."
    ],
    "description": "More likely by Full-time Managers and talent with 3 Charisma.",
    "conflicting_requests": [
      "write_off",
      "no_weekly_shows",
      "change_brand"
    ],
    "rarity": "uncommon"
  },
  "win_and_not_lose": {
    "negative_request": true,
    "display_name": "Win Clean And Don't Lose",
    "name": "Win Clean And Don't Lose (Singles)",
    "secondary_action": true,
    "importance": "major",
    "dialogs": [
      "I need to get more wins under my belt. And I don't think I should take any losses, not for a while.",
      "It's time to start booking me strong. I need to win some matches. And no losses, alright?",
      "I'm a valuable asset to this company and I need to be protected. You should book me to get some wins and go over anyone I face."
    ],
    "description": "More likely by Unhappy talent, Faces of the Company and those with the Hard To Please or Rebel traits.",
    "conflicting_requests": [
      "put_x_over_clean",
      "lose_next_match"
    ],
    "months": [
      2,
      3
    ],
    "rarity": "normal"
  },
  "lose_next_match": {
    "months": [
      1
    ],
    "display_name": "Lose Next Match",
    "name": "Lose Next Match (Singles)",
    "importance": "minor",
    "dialogs": [
      "I've been winning quite a few matches lately, and I think it's time for me to take a loss. Don't want to be too dominant.",
      "I want to lose my next match. I've been winning a few and I should give someone the rub instead.",
      "I'm in the position where I can elevate people by putting them over. I'd like to lose to someone in my next match.",
      "I'm at the point where I should be building up other talent. How about you book me to lose my next match?"
    ],
    "description": "More likely by talent with 5+ match win streaks and those with the Giving Veteran or Star Maker traits.",
    "conflicting_requests": [
      "win_next_match",
      "no_clean_loss",
      "no_weekly_shows",
      "win_and_not_lose"
    ],
    "rarity": "common"
  },
  "put_x_over_clean": {
    "months": [
      1
    ],
    "display_name": "Put X Over Clean",
    "name": "Put ${talentName} Over Clean (Singles)",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "I've been thinking about wrestling ${talentName}. If we do have a match, ${talentPronoun} should get a clean win over me.",
      "${talentName} is a great talent in my eyes. I'd like to be in a match against ${talentObjective} where ${talentPronoun} goes over clean.",
      "It's time for me to elevate someone by giving them a win. How about ${talentName}?",
      "I should be putting other talent over. How about a match with ${talentName} where ${talentPronoun} wins clean?"
    ],
    "description": "More likely by talent with the Spotlight Lover, Giving Veteran or Star Maker traits.",
    "conflicting_requests": [
      "no_clean_loss",
      "win_and_not_lose"
    ],
    "rarity": "common"
  },
  "join_faction": {
    "allow_managers": true,
    "months": [
      1,
      2
    ],
    "display_name": "Join Faction",
    "name": "Join Faction (${factionName})",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "${factionName} could use a hot new member. How about you add me to the group?",
      "I've been talking to members of ${factionName} and they want me to join their group. How about you book that into the story?",
      "I would be a good fit in ${factionName}. They could use someone like me and I'd benefit from being part of the faction."
    ],
    "description": "More likely by Upper Midcarders.",
    "conflicting_requests": [
      "write_off",
      "change_brand"
    ],
    "rarity": "uncommon"
  },
  "be_in_main_event": {
    "months": [
      1
    ],
    "display_name": "Be In The Main Event",
    "name": "Be In The Main Event",
    "importance": "minor",
    "dialogs": [
      "I know I'll do well if you gave me an opportunity to be in the main event of the show.",
      "I'd like to be booked in the main event soon. The spotlight could help elevate me.",
      "What do you think about booking me in the main event? I know I can deliver in that spot.",
      "I would benefit a lot from being in the main event of the show. And you know I'll give it my best."
    ],
    "description": "More likely by Unhappy talent, Upper Midcarders and those with the Spotlight Lover, Hard To Please or Rebel traits.",
    "conflicting_requests": [
      "no_weekly_shows"
    ],
    "rarity": "common"
  },
  "change_alignment": {
    "allow_managers": true,
    "months": [
      2,
      3
    ],
    "display_name": "Turn Face/Heel",
    "name": "Turn ${alignment}",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "You might've noticed that I'm not working too well as a ${currentAlignment} character. How about I turn ${alignment} over the next few months?",
      "My ${currentAlignment} character doesn't feel right anymore. I'm due for a ${alignment} turn.",
      "I think we have a good opportunity right now to turn me ${alignment}. It would make for a nice story over the coming months."
    ],
    "description": "More likely by talent with the Natural Babyface or Natural Heel traits (with the wrong alignment) and those who have spent 12+ months with the same alignment.",
    "conflicting_requests": [
      "write_off"
    ],
    "rarity": "uncommon"
  },
  "win_a_championship": {
    "months": [
      2,
      3
    ],
    "display_name": "Win A Championship",
    "name": "Win A Championship",
    "importance": "major",
    "dialogs": [
      "You know the spotlight that comes with being a champion? I need that.",
      "You know, I could elevate any championship in the company. Give me a title and you'll see.",
      "I feel like it's time for me to hold a championship. You know I deserve it."
    ],
    "description": "More likely by Unhappy talent and those with the Hard To Please or Rebel traits.",
    "conflicting_requests": [
      "write_off"
    ],
    "rarity": "normal"
  },
  "match_with_x": {
    "months": [
      1
    ],
    "display_name": "Have A Match With X",
    "name": "Have A Match With ${talentName} (Singles)",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "${talentName} is an amazing wrestler and I think the two of us could have a memorable match against each other.",
      "I would really like a singles match against ${talentName}. We could tear the house down together.",
      "I've been looking at talent to work with and I believe ${talentName} would be a perfect opponent for me.",
      "I was talking with ${talentName}, and we agreed that we could do some fantastic things if you put us in a match together."
    ],
    "description": "More likely by talent with 3 Workrate and those with the Ring General or Workhorse traits.",
    "conflicting_requests": [],
    "rarity": "common"
  },
  "go_to_next_rank": {
    "months": [
      2,
      3
    ],
    "display_name": "Become Rank X",
    "name": "Become ${rank}",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "I think it's time for me to move up the card to ${rankIndefiniteArticle} ${rank}. It feels like the right moment.",
      "I can sense that I'm close to becoming ${rankIndefiniteArticle} ${rank}. We could do it over the next few months.",
      "I've earned my way up to ${rankIndefiniteArticle} ${rank}. It's time to pull the trigger on it.",
      "I know I can do really well as ${rankIndefiniteArticle} ${rank}. Give me the shot and I'll prove it."
    ],
    "description": "Given by talent close to the next Rank. More likely by Unhappy talent and those with the Spotlight Lover, Hard To Please or Rebel traits.",
    "conflicting_requests": [
      "write_off"
    ],
    "rarity": "common"
  },
  "vacate_championship": {
    "months": [
      1,
      2
    ],
    "display_name": "Vacate Championship",
    "name": "Vacate ${championshipName} Championship",
    "get_action_data": true,
    "importance": "major",
    "dialogs": [
      "I feel like it's time for me to drop the ${championshipName} Title, but I'm not in the position to lose it to anybody. Maybe you could vacate it instead?",
      "I'm a strong champion, and my reign can't end with me losing to someone. I think you should vacate the ${championshipName} Title to get it off me.",
      "I can sense that my title reign should be over, but I don't believe I should lose it to someone. What if I go out and say something like .. I don't know .. I lost my smile?"
    ],
    "description": "More likely by Unhappy talent, Faces of the Company and those with the Hard To Please or Rebel traits.",
    "conflicting_requests": [
      "customize_championship"
    ],
    "rarity": "rare"
  },
  "beat_x_clean": {
    "months": [
      1,
      2
    ],
    "display_name": "Beat X Clean",
    "name": "Beat ${talentName} Clean (Singles)",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "${talentName} would really benefit from a match against someone like me. Of course, I should go over, but even facing me will cement ${talentObjective} as a star.",
      "${talentName} is getting a little popular. You should put us in a match to establish ${talentObjective} .. even losing to me will help ${talentObjective} out.",
      "I've been thinking about facing ${talentName}. A match against me would be great for ${talentObjective}. But, you know, I'll have to win."
    ],
    "description": "More likely by Faces of the Company and talent with the Hard To Please or Rebel traits.",
    "conflicting_requests": [],
    "rarity": "uncommon"
  },
  "change_appearance": {
    "allow_managers": true,
    "months": [
      0,
      1
    ],
    "display_name": "Change Appearance",
    "name": "Change Appearance",
    "importance": "minor",
    "dialogs": [
      "I think a change in appearance could help freshen up my character. Maybe some new hair, or accessories?",
      "You know what would really help me? A new look. Even a little change could work.",
      "I'm bored of my look. A small makeover would do wonders for my character."
    ],
    "description": "More likely by Stale talent.",
    "conflicting_requests": [
      "write_off"
    ],
    "rarity": "normal"
  },
  "feud_with_x": {
    "months": [
      1,
      2
    ],
    "display_name": "Feud With X",
    "name": "Feud With ${talentName} (Singles)",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "I've had my eyes on ${talentName} for a while now. A feud between us would be perfect.",
      "I think ${talentName} and I should be in a feud against each other. We could do some amazing stuff.",
      "${talentName} was talking to me and we thought of some great ideas for a feud. What do you think about putting us against each other?",
      "${talentName} and I were talking, and we agreed that we could put together a great feud."
    ],
    "description": "More likely by talent with the Storyteller trait.",
    "conflicting_requests": [],
    "rarity": "common"
  },
  "no_weekly_shows": {
    "negative_request": true,
    "display_name": "No Weekly Shows",
    "name": "No Weekly Shows",
    "months": [
      2,
      3
    ],
    "importance": "major",
    "dialogs": [
      "Some important stuff has come up and I don't know if I can be on the weekly shows right now. Could you save my appearances for the monthly events?",
      "My schedule's gotten a bit busy and I don't think I can do weekly appearances for a few months. How about you only use me at the monthly events?",
      "My body can't go every week right now. It might be best to save my appearances for the next few monthly events.",
      "You know, I don't perform too well on the weekly shows. How about a bit of a break? Save me for the monthlies?"
    ],
    "description": "More likely by Part-timers and talent with the Other Interests or Weekly Sloth traits.",
    "conflicting_requests": [
      "solo_promo_segment",
      "be_in_main_event",
      "win_next_match",
      "lose_next_match",
      "team_with_x",
      "manage_x",
      "be_managed",
      "start_faction",
      "train_skill_x"
    ],
    "rarity": "uncommon"
  },
  "no_clean_loss": {
    "negative_request": true,
    "display_name": "Can't Lose Clean",
    "name": "Can't Lose Clean (Singles)",
    "months": [
      1,
      2
    ],
    "importance": "major",
    "dialogs": [
      "I feel like I need to be protected more. A clean loss won't be good for me right now.",
      "I can't afford to take a clean loss right now. My character need to be protected.",
      "I can't go out there and lose clean right now. You know how much that would hurt my character."
    ],
    "description": "More likely by Unhappy talent, Faces of the Company and those with the Hard To Please or Rebel traits.",
    "conflicting_requests": [
      "put_x_over_clean",
      "lose_next_match"
    ],
    "rarity": "normal"
  },
  "train_skill_x": {
    "months": [
      3
    ],
    "display_name": "Train Skill X",
    "name": "Train ${skill}",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "I know I need to improve my ${skill} and training is the best way to do it. How about you hook me up with the trainer for a few months?",
      "How about some focused training for my ${skill}, boss? I heard the trainer can do wonders in a few months.",
      "You must've noticed that my ${skill} isn't that good. How about some one on one time with the trainer to help me improve?",
      "Could you assign the trainer to help me with my ${skill}? I think I could make some decent progress in a few months."
    ],
    "description": "More likely by talent with the Loves Training or Quick Learner traits.",
    "conflicting_requests": [
      "no_weekly_shows",
      "write_off"
    ],
    "rarity": "normal"
  },
  "write_off": {
    "months": [
      1
    ],
    "display_name": "Write Me Off",
    "name": "Write Me Off",
    "importance": "major",
    "dialogs": [
      "Now's a good time to write me off. Do something cool that tells the fans that I won't be returning for a while.",
      "Some other commitments have come up and I need focus on them. You can write me off however you want, but I don't want to be active much longer.",
      "I can't do this much longer .. I need to focus on other things. You can do a fake injury angle or a suspension or something."
    ],
    "description": "More likely by Part-timers and talent with the Other Interests trait.",
    "conflicting_requests": [
      "go_to_next_rank",
      "win_a_championship",
      "start_faction",
      "manage_x",
      "be_managed",
      "customize_championship",
      "team_with_x",
      "change_appearance",
      "debut_new_gimmick",
      "change_alignment",
      "join_faction",
      "be_on_monthly_event",
      "train_skill_x"
    ],
    "rarity": "uncommon"
  },
  "customize_championship": {
    "months": [
      1
    ],
    "display_name": "Customize Championship",
    "name": "Customize ${championshipName} Championship",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "The ${championshipName} Championship looks great on me, but I was thinking we could customize the belt to add some style to my reign.",
      "I got a neat idea. How about we add a unique design for my ${championshipName} Title? All the cool champions did it.",
      "I could do more with the ${championshipName} Title if it was personalized. Maybe we could add a custom design for the belt?"
    ],
    "description": "Given by talent less than 4 months into their title reigns.",
    "conflicting_requests": [
      "write_off",
      "lose_championship",
      "vacate_championship"
    ],
    "rarity": "rare"
  },
  "be_in_gimmick_match": {
    "months": [
      1
    ],
    "display_name": "Be In A Gimmick Match",
    "name": "Be In A Gimmick Match",
    "importance": "minor",
    "dialogs": [
      "I'm craving a gimmick match. How about you book me in one this month?",
      "I want to show the fans some new things and a gimmick match seems like the perfect way to do it.",
      "You should put me in a gimmick match this month. I want to use it to tell a different kind of story in the ring.",
      "Gimmick matches might be overdone, but I feel like I could do something cool if you put me in one."
    ],
    "description": "More likely by talent with the Risk Taker, Gifted Acrobat or Enjoys Gimmick Matches traits.",
    "conflicting_requests": [],
    "rarity": "common"
  },
  "be_on_monthly_event": {
    "allow_managers": true,
    "months": [
      1
    ],
    "display_name": "Be Booked At Monthly Event",
    "name": "Be Booked At Monthly Event",
    "importance": "minor",
    "dialogs": [
      "You didn't use me on the last monthly event .. could you make some plans for me this month?",
      "The next monthly event is in my hometown, and I would appreciate if you can put me on the card. The whole family's going to be watching.",
      "I'd really appreciate being booked on the upcoming monthly event this time. Could you put me in a match or segment?",
      "I think I should be booked on the upcoming monthly event, especially after not being part of last month's show."
    ],
    "description": "Given by talent not booked at the previous monthly event.",
    "conflicting_requests": [
      "write_off"
    ],
    "rarity": "common"
  },
  "beat_main_eventer": {
    "months": [
      1,
      2
    ],
    "display_name": "Beat A Main Eventer",
    "name": "Beat A Main Eventer (Singles)",
    "importance": "minor",
    "dialogs": [
      "I'm at the position where I can legitimately beat a Main Eventer, and I believe the fans want to see it too.",
      "I'm ready to take on a Main Eventer and beat them. Don't you think so?",
      "The fans are ready to see me get a win against a Main Eventer. It'll really help me out."
    ],
    "description": "More likely by Unhappy talent, Upper Midcarders and those with the Spotlight Lover, Hard To Please or Rebel traits.",
    "conflicting_requests": [],
    "rarity": "common"
  },
  "disband_team": {
    "months": [
      2,
      3
    ],
    "display_name": "Disband Team",
    "name": "Disband Team (${teamName})",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "I'm picking up some momentum as a solo performer, and maybe it's time for me to do my own thing.",
      "I love my tag partner, but I feel like I would be better off as a singles superstar. What do you think?",
      "I think it's time for me to break away from ${teamName} and go on a singles run. I need to see what I can do on my own.",
      "Being part of ${teamName} isn't working for me anymore. My partner and I had a long talk, and we think it's best for us to break up."
    ],
    "description": "More likely by Over talent.",
    "conflicting_requests": [],
    "rarity": "uncommon"
  },
  "be_in_gimmick_match_x": {
    "months": [
      1
    ],
    "display_name": "Be In Gimmick Match X",
    "name": "Be In A Gimmick Match (${gimmickMatchName})",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "I got a few ideas for a ${gimmickMatchName} match running around in my head. Could you put me in one soon?",
      "Let's do a ${gimmickMatchName} match soon. I really wanna be in one and I know the fans will love it.",
      "${gimmickMatchName} match. ASAP.",
      "I've had this recent fascination with ${gimmickMatchName} matches .. could you book me in one?"
    ],
    "description": "More likely by talent with the Risk Taker, Gifted Acrobat, Enjoys Gimmick Matches or Match Expert traits.",
    "conflicting_requests": [],
    "rarity": "normal"
  },
  "change_brand": {
    "allow_managers": true,
    "months": [
      2,
      3
    ],
    "display_name": "Move to Brand X",
    "name": "Move to ${brandName}",
    "get_action_data": true,
    "importance": "minor",
    "dialogs": [
      "Staying on ${currentBrandName} isn't working for me right now. Could you perhaps transfer me over to ${brandName}? I think I'll be better off there.",
      "I've spent enough time on ${currentBrandName} to know it's not the right fit for me. Could you move me to ${brandName} instead?",
      "${currentBrandName} is great, but I have a lot of friends over at ${brandName} and I'd like to join them. Maybe you could move me there?"
    ],
    "description": "More likely by Unhappy talent.",
    "conflicting_requests": [
      "start_faction",
      "join_faction",
      "team_with_x",
      "manage_x"
    ],
    "rarity": "uncommon"
  }
};

const talentRequestCommonDialogs = {
    'requestAccepted': ["You're a smart booker.",
        "Yes!",
        "Thanks!",
        "Thank you.",
        "I didn't expect you to agree to that.",
        "Wow, thank you.",
        "Thanks for listening to me.",
        "That's what I'm talking about.",
        "Thanks a bunch.",
        "I'll be very grateful.",
        "I'm looking forward to it.",
        "I knew you were a good person.",
        "Good booker.",
        "Thanks, boss.",
        "I knew you were on my side.",
        "I knew I could count on you.",
        "That's great.",
        "Thanks for agreeing with me.",
        "You actually listened .. thanks.",
        "Okay, hope it works out.",
        "That's very nice of you.",
        "Beautiful.",
        "I appreciate it.",
        "Can't wait!",
        "Awesome."],
    'requestCompleted': ["Thanks a lot for listening to me. You're a good boss.",
                          "You did as I asked. That doesn't happen very often in this business.",
                          "I'm grateful you did as I asked. This is going to help me out a lot.",
                          "Thank you for taking care of me. I owe you one.",
                          "Thanks for dealing with my request, boss. I know it wasn't easy.",
                          "You did the right thing. Thank you.",
                          "I know I made a tough request, but you did as I asked, and I'll try to repay the favour.",
                          "I know I didn't make the easiest request in the world, so thank you.",
                          "Hey, thanks a lot for listening to me. You did as I asked, and I'm very grateful.",
                          "Thanks. I know I'm not the easiest person to work with, but I'll try to be better from now on.",
                          "I'm quite happy with how that turned out. Thank you.",
                          "Other bookers might not have done that for their talent, but you're one of the good ones."
                          ],
    'requestFailed': ["What the #@!&? I thought we had an understanding!",
                       "This sucks. Maybe I asked for a lot .. but I know you could've done more.",
                       "You couldn't even do what we discussed? How do you expect me to be happy here?",
                       "I asked you for one thing. ONE THING. And you can't even do that?",
                       "It was a bad decision to not listen to me. I'll do my best to make your life more difficult from now on.",
                       "You need to start listening to your talent, or the locker room is going to turn against you.",
                       "You should've taken better care of my needs. I could easily find another place that treats me better.",
                       "I thought we had a deal! It's really disappointing to be treated like this.",
                       "You gave me your word. This is going to come back to bite you .. ",
                       "I can't believe I trusted you. This really sucks.",
                       "You said you would do it .. I can't believe I fell for it.",
                       "This was important to me, and you just ignored it? After you said you would work on it?!"
                       ],
    'requestDeclined': {
        'major': ["What? I thought I could trust you with things like this!",
                  "I really thought you would treat me better than this.",
                  "So, I come to you with a personal request, and you just decline it? This sucks.",
                  "You didn't even try to work on my request. This is beyond disappointing.",
                  "That's it, you're just saying no? And you expect me to be happy here?",
                  "That's a really bad decision you made and you're going to regret it.",
                  "Right, I forgot you're the booker, playing with us like we're your puppets.",
                  "You know, there are other places where talent are treated much better.",
                  "I thought I could come to you with stuff like this. That was important to me .. ",
                  "This blows. I can't trust you with things important to me.",
                  "You treat us like crap. Like we're some characters you're managing in a video game."
                  ],
        'minor': [
            "You know, that was important to me.",
            "You should've given that more thought.",
            "Okay .. ",
            "Right, okay .. ",
            "Oh .. alright.",
            "Fine, I guess we'll go with your decision.",
            "I don't think you made the right choice there.",
            "You could've trusted me on that.",
            "I'm not too happy about this.",
            "Fine, there's not much else to say.",
            "Really? I thought it was a decent idea.",
            "Okay, fine. I have to go.",
            "I guess we don't see eye to eye on that.",
            "I somehow thought you would agree to that.",
            "Damn, I was looking forward to that .. ",
            "Of course. You always get the final say.",
            "Okay, whatever. I guess that's fine.",
            "That was important to me.",
            "I guess I have a different opinion then.",
            "I think that's the wrong decision, but fine."
        ]
    },
    'acceptRequest': [
        "I'll see what I can do.",
        "Sure, we can do that.",
        "You got it.",
        "That will work.",
        "Let's do it!",
        "I think we can do that.",
        "Consider it done.",
        "Okay, let's do it.",
        "I can manage that.",
        "That'll work out quite well, actually.",
        "I was already thinking of that.",
        "I can incorporate that.",
        "That's actually exciting.",
        "That works for me.",
        "I think that's a great idea."
    ],
    'declineRequest': [
        "Sorry, pal. Can't do this.",
        "That's a stupid idea.",
        "We can't do this right now.",
        "That doesn't work for me.",
        "Are you kidding?",
        "That's a bad idea.",
        "This won't work right now.",
        "Sorry, that's a no from me.",
        "Nope.",
        "Now's not the right time.",
        "Sorry.",
        "I don't think so.",
        "That doesn't go with the plans.",
        "Sorry, I have to say no.",
        "I don't think that will work."
    ],
    'changeRequest': [
        "Could you try asking for something else?",
        "Is there something else I could do for you?",
        "Is there some other thing I can do for you?",
        "Maybe there's something else you can ask for?",
        "Maybe you have another idea?",
        "Do you have another idea?",
        "Could you reconsider and ask for something else?",
        "I might be able to do something else for you.",
        "Is there another request you had in mind?",
        "Try me with something else.",
        "Ask me for something else? I'll owe you one.",
        "Ask me for something else, pal."
    ],
    'changeDeclined': [
        "No, this is what I want.",
        "No, I want this.",
        "Nope.",
        "Can't think of anything else.",
        "Why, so you can shoot that down too?",
        "Why, is this too difficult for you?",
        "No. You should be able to do this for me.",
        "No.",
        "You may be able to get other people to change their minds, but not me.",
        "I'm not going to bend on my request like some other talent do.",
        "No. Give me what I want.",
        "Why would I want anything else?"
    ],
    'changeAccepted': [
        "There is something else you could do for me .. ",
        "Okay, sure .. ",
        "Okay, hear me out now.",
        "There is this other thing I wanted to ask you for.",
        "Now that you mention it .. ",
        "Okay, how about this .. ",
        "Actually, there is something else .. ",
        "I did have another idea.",
        "I guess I could think of something else.",
        "Okay, I got an even better idea.",
        "I can't believe you're making me change my request, but okay.",
        "How dare you .. ugh, fine."
    ]
};

export {talentRequestsData, talentRequestCommonDialogs}